import React, { useEffect, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./navbar.css";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      updateNavbar(window.scrollY >= 20);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "site-navbar sticky" : "site-navbar"}
    >
      <Container className="nav-shell">
        <Navbar.Brand as={Link} to="/" className="brand-mark">
          <span className="brand-copy">
            <strong>Shankar Kharel</strong>
            <small>Software Engineer</small>
          </span>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => updateExpanded(expand ? false : "expanded")}
        >
          <div className="toggleButton">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto nav-links">
            <Nav.Item>
              <Nav.Link
                as={NavLink}
                to="/"
                end
                onClick={() => updateExpanded(false)}
              >
                Home
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                as={NavLink}
                to="/about"
                onClick={() => updateExpanded(false)}
              >
                About
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                as={NavLink}
                to="/project"
                onClick={() => updateExpanded(false)}
              >
                Experiences
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                href="https://des-vu-technologies.gitbook.io/blogs-by-shankar/"
                target="_blank"
                rel="noreferrer"
              >
                Writing
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="nav-actions">
            <Link
              className={`nav-contact ${location.pathname === "/contact" ? "active" : ""}`}
              to="/contact"
              aria-label="Contact Shankar Kharel"
              onClick={() => updateExpanded(false)}
            >
              Contact
            </Link>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
